import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LuUndo } from "react-icons/lu";

const UndoButton = ({ label = "Undo", onClick = () => {}, disabled = false }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={t(label)}>
      <span>
        <IconButton onClick={onClick} disabled={disabled} variant="Light Green">
          <LuUndo />
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default UndoButton;
